import { Modal, Button, Badge } from "react-bootstrap";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import swal from "sweetalert";

import { assignLeadsToTelecaller } from "../../../../../services/LeadService";
import { updateCallStatusAction, markCallReceivedAction } from "../../../../../store/actions/callActions";
import { formatName } from "../../../../../utils/formatName";
import { fetchUnreceivedCallLeads, routeToServiceCallerAction } from "../../../../../store/actions/telecallerActions";

const CallPopup = ({ show, onHide, lead }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [routing, setRouting] = useState(false);
  if (!lead) return null;

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const telecaller_id = userDetails?.admin_id;
  // const [routing, setRouting] = useState(false);

  // Check if mobileNo_exist_count is greater than 0
  const hasExistingMobile = lead.mobileNo_exist_count && parseInt(lead.mobileNo_exist_count) > 0;

  // ============================
  // CALL RECEIVED
  // ============================
  const handleCallReceived = async () => {
    const payload = {
      lead_id: lead.lead_id,
      telecaller_notes:
        "Patient answered the call and showed interest. Scheduled for consultation",
      admin_id: telecaller_id,
    };

    try {
      await dispatch(markCallReceivedAction(payload));
      onHide();
      navigate(`/app-lead-details/${lead.lead_id}`);
    } catch (err) {
      console.error(err);
    }
  };


  // ============================
  // CALL NOT RECEIVED
  // ============================
  const handleCallNotReceived = async () => {
    if (!telecaller_id) {
      swal("Error", "Telecaller ID missing", "error");
      return;
    }

    const payload = {
      call_status: "not_received",
      lead_id: lead.lead_id,
      telecaller_notes:
        "Phone was ringing but no one answered. Will try again later.",
      admin_id: telecaller_id,
    };

    try {
      await dispatch(updateCallStatusAction(payload));

      // 🔥 Refresh list after update
      dispatch(
        fetchUnreceivedCallLeads({
          pagination: false,
          pageid: 1,
          search_by: "",
          search_keyword: "",
          sort_by: "",
          sort_order: "",
          admin_id: telecaller_id,
        })
      );

      onHide();
    } catch (error) {
      console.error("Call status error:", error);
    }
  };

  // ============================
  // ROUTE TO SERVICE CALLER
  // ============================
  // const handleRouteToServiceCaller = () => {
  //   onHide();
  //   // Navigate to service caller page with the lead data
  //   navigate("/service-caller", {
  //     state: {
  //       leadId: lead.lead_id,
  //       mobileNumber: lead.mobile,
  //       existingCount: lead.mobileNo_exist_count
  //     }
  //   });
  // };

  const handleRouteToServiceCaller = async () => {
    try {
      setRouting(true); // 🔥 start disable

      const payload = {
        lead_id: lead.lead_id,
      };

      const res = await dispatch(routeToServiceCallerAction(payload));

      if (res.success) {
        swal("Success", "Lead routed to Service Caller", "success");

        dispatch(fetchUnreceivedCallLeads({
          pagination: false,
          pageid: 1,
          search_by: "",
          search_keyword: "",
          sort_by: "",
          sort_order: "",
          admin_id: telecaller_id,
        }));

        onHide();
        navigate("/service-caller");
      } else {
        swal("Error", res.message || "Something went wrong", "error");
      }
    } catch (err) {
      console.error(err);
      swal("Error", "Failed to route lead", "error");
    } finally {
      setRouting(false); // 🔥 enable back
    }
  };
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center gap-2">
          Call Lead
          {hasExistingMobile && (
            <Badge bg="danger" pill>
              {lead.mobileNo_exist_count}
            </Badge>
          )}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>
          <strong>Name:</strong> {formatName(lead.name || "-")}
        </p>
        <p>
          <strong>Mobile:</strong> {lead.mobile || "-"}
        </p>
        <p>
          <strong>Disease:</strong> {formatName(lead.disease || "-")}
        </p>
        <p>
          <strong>City:</strong> {formatName(lead.city || "-")}
        </p>

      </Modal.Body>

      <Modal.Footer className="d-flex gap-2">

        {hasExistingMobile && (
          <Button
            variant="info"
            onClick={handleRouteToServiceCaller}
            className="flex-fill text-white"
            size="sm"
            disabled={routing} // 🔥 disable
          >
            {routing ? "Routing..." : "Route to Service Caller"} {/* 🔥 text change */}
          </Button>
        )}

        <Button
          variant="danger"
          onClick={handleCallNotReceived}
          className="flex-fill"
          size="sm"
        >
          Call Not Received
        </Button>

        <Button
          variant="success"
          onClick={handleCallReceived}
          className="flex-fill"
          size="sm"
        >
          Call Received
        </Button>

      </Modal.Footer>
    </Modal>
  );
};

export default CallPopup;